import React, { createContext } from 'react';

const ModalContext = createContext({});

export { ModalContext };
